<template>
  <div class="drawDetail">
    <div class="con flex jb ">
      <div flex-center class="close" @click="back"><i class="el-icon-close"></i></div>
      <div class="big_img" flex-center>
        <el-image fit="contain" :src="square_data.img_url"
                  :preview-src-list="[square_data.raw_img_url]"></el-image>
      </div>
      <div class="text_area">
        <div class="user flex jb ac">
          <div class="info flex  ac">
            <div class="avatar">
              <img src="@/views/objIcon/MJ.png"
                   alt=" "/>
            </div>
            <div class="name">
              <p class="nickname">白日梦</p>
              <p class="flex ac"><img src="./img/icon_img50.png" style="color: #FC8C0A;"
                                      alt=" "/><span>{{ square_data.views }}</span><img src="./img/icon_img51.png"
                                                                                        alt=" "/><span>{{ square_data.votes }}</span>
              </p>
            </div>
          </div>
          <div class="right_box1">
            <div class="fav " @click="handleVote">
              <img src="./img/icon_img51.png"
                   alt=" "/>
              <p>点赞</p>
            </div>
            <div class="fav" @click="down_draw_list">
              <i class="el-icon-download" style="font-size: 14px;margin-right: 4px;padding-top: 2px"></i>
              <p>下载</p>
            </div>
          </div>

        </div>
        <div class="item">
          <div class="title flex jb ac">
            <p>提示词</p>
            <p class="flex ac" v-clipboard:copy="square_data.prompt" v-clipboard:success="copySuccess"
               v-clipboard:error="copyError"><img src="./img/icon_img52.png" alt=" "/><span>复制</span></p>
          </div>
          <div class="desc">
            {{ square_data.prompt }}
          </div>
        </div>
        <div class="item">
          <div class="title flex jb ac">
            <p>英文</p>
            <p class="flex ac" v-clipboard:copy="square_data.prompt_en" v-clipboard:success="copySuccess"
               v-clipboard:error="copyError"><img src="./img/icon_img52.png"
                                                  alt=" "/><span>复制</span></p>
          </div>
          <div class="desc">
            {{ square_data.prompt_en }}
          </div>
        </div>
        <div class="item">
          <div class="title flex jb ac">
            <p>参数信息</p>
          </div>
          <div class="desc">
            <div class="params_item flex ac">
              <p class="title">绘制模型</p>
              <p class="tips">{{ square_data.img_model }}</p>
            </div>
            <div class="params_item flex ac">
              <p class="title">图片比例</p>
              <p class="tips">{{ square_data.aspect }}</p>
            </div>
            <div class="params_item flex ac">
              <p class="title">图片尺寸</p>
              <p class="tips">{{ square_data.width }}:{{ square_data.height }}</p>
            </div>
            <div class="params_item flex ac">
              <p class="title">高级参数</p>
              <p class="tips">{{ square_data.parameters }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewLoginPanel v-if="show_login_compoments"></NewLoginPanel>
  </div>
</template>

<script>
import utils from "@/utils";
import NewLoginPanel from "COMPONENTS/NewLoginPanel.vue";

export default {
  components: {NewLoginPanel},
  data() {
    return {
      draw_id: this.$route.query.draw_id || 0,
      square_data: {},
      is_vote: 0
    }
  },
  computed: {
    show_login_compoments() {
      return this.$store.state.show_login_compoments
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
  },
  created() {
    this.getData()
    this.fetchProfile()
  },
  methods: {
    fetchProfile() {
      this.$http.get(`/front/user/profile/`).then(res => {
        if (res.status == '200') {
          this.$store.commit('setUserInfo', res.data)
          this.$store.commit('setIsLogin', true)
          this.$store.commit('setShowLogin', false)
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("invite_code", res.data.invite_code);
        }
      }).catch(err=>{
        localStorage.removeItem('isTodyYouh')
        localStorage.removeItem('getY')
        localStorage.removeItem('paynum')
        var ua = navigator.userAgent.toLowerCase()
        if ((ua.match(/MicroMessenger/i) == "micromessenger")) {
          // 微信自动登录
          window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
        }
      }).finally(() => {

      })
    },
    getData() {
      //发送请求
      this.$http.get(`/front/aimj/draw/${this.draw_id}/`).then((res) => {
        this.square_data = res.data
      })
    },
    back() {
      this.$router.go(-1)
    },
    handleVote() {
      this.$http.patch(`/front/aimj/draw/${this.draw_id}/`, {action: 'vote'}).then((res) => {
        if (this.is_vote) {
          this.is_vote = 0
          this.square_data.votes = this.square_data.votes - 1
        } else {
          this.is_vote = 1
          this.square_data.votes = this.square_data.votes + 1
        }
      })
    },
    down_draw_list() {
      // 下载
      if (!this.checkLogin()) return
      console.log('作品下载')
      this.$http.get(`/front/aimj/draw/down/${this.draw_id}/`,).then(res => {
        if (res.status == '200') {
          window.location.href = res.data.url
        } else {
          let message = res.message
          utils.createErrTip(message)
        }
      }).catch(err => {
        let message = err.message;
        utils.createErrTip(message)
      }).finally(() => {
        this.loading = false
      })


    },
    copySuccess() {
      this.$message.success('复制成功！');
    },
    copyError() {
      this.$message.error('复制失败！');
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)

          if (this.isWxEnv) {
            // 微信环境内
            window.location.href = `${API_SERVER}/api/wx/oauth/?appid=${APP_ID}`
          } else {
            this.$store.commit('setShowLogin', true)
          }
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }

    },
  }
}
</script>

<style lang="scss" scoped>
.drawDetail {
  height: 100%;
  padding: 20px;
  overflow-y: auto;

  .con {
    flex-wrap: wrap;
    width: 100%;
    padding: 16px;
    background: #303237;
    border-radius: 15px;
    position: relative;
    font-size: 12px;

    .close {
      background-color: #414141;
      right: 10px;
      top: 10px;
      position: fixed;
      z-index: 100;
      height: 50px;
      width: 50px;
      border-radius: 25px;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
    }

    .big_img {
      flex: 1;
      max-width: 100%;
      height: 600px;

      .el-image {
        width: 100%;
        height: 100%;
      }
    }

    .text_area {
      .user {
        margin-bottom: 34px;

        .info {
          .avatar {
            width: 46px;
            height: 46px;
            background: #acacac;
            border-radius: 100%;
            overflow: hidden;
            margin-right: 10px;

            img {
              width: 100%;
            }
          }

          .name {
            p {
              img {
                width: 16px;
                height: 16px;
                opacity: 0.5;
              }

              span {
                margin-left: 5px;
                margin-right: 10px;
                font-size: 12px;
                color: #999;
                position: relative;
                top: 2px;
              }
            }

            .nickname {
              font-size: 14px;
              color: #fff;
              margin-bottom: 5px;
            }
          }
        }

        .right_box1 {
          display: flex;
        }

        .fav {
          width: 60px;
          height: 34px;
          border-radius: 40px;
          background: #000;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 6px;

          img {
            width: 16px;
            height: 16px;
            margin-right: 5px;
          }

          p {
            font-size: 12px;
            color: #fff;
          }

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .item {
        margin-top: 10px;

        .title {
          p {
            font-size: 14px;
            color: #fff;
          }

          img {
            width: 24px;
            height: 24px;
            opacity: 0.7;
          }

          span {
            font-size: 12px;
            color: #999;
          }

          .flex {
            cursor: pointer;

            &:hover {
              img {
                opacity: 1;
              }

              span {
                color: #fff;
              }
            }
          }
        }

        .desc {
          background-color: #262626;
          color: #fff;
          padding: 16px;
          min-height: 60px;
          //max-height: 160px;
          border-radius: 10px;
          line-height: 1.7;
          margin-top: 10px;

          .params_item {
            padding: 5px 0;

            .title {
              color: #949ba4;
              margin-right: 10px;
            }

            .tips {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>